"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _dropdownMenu = _interopRequireDefault(require("../dropdownMenu"));
var _FormContext = _interopRequireDefault(require("./FormContext"));
var _FormSelectOption = _interopRequireDefault(require("./FormSelectOption"));
var _components = require("./components");
const FormSelect = _ref => {
  let {
    id,
    selected,
    className,
    children,
    icon,
    state,
    required,
    readOnly,
    managed,
    onChange,
    onFocus,
    onBlur
  } = _ref;
  const {
    controlId,
    isFocus,
    required: inputIsRequired,
    // TODO: Handle required in association with state prop
    onBlur: onInputBlur,
    onFocus: onInputFocus,
    onRequiredChange,
    setState
  } = _react.default.useContext(_FormContext.default);
  const inputRef = _react.default.useRef(null);
  const [openMenu, setOpenMenu] = _react.default.useState(false);
  const internalValueOptions = _react.default.useMemo(() => ({
    locked: managed !== true && isFocus
  }), [isFocus, managed]);
  const [internalSelectedOption, setInternalSelectedOption] = (0, _arkReact.useInternalValueManager)(selected, internalValueOptions);
  _react.default.useEffect(() => setState?.(state), [state]);
  _react.default.useEffect(() => onRequiredChange?.(required ?? false), [required, onRequiredChange]);
  const onItemClick = _react.default.useCallback((itemValue, event) => {
    setOpenMenu(false);
    setInternalSelectedOption(itemValue);
    onChange?.(itemValue, event);
  }, [setOpenMenu, onChange, setInternalSelectedOption]);
  const selectOptions = _react.default.useMemo(() => (0, _arkReact.childrenToReactElement)(children).filter(elementItem => elementItem.type.displayName === 'FormSelectOption').map(elementItem => elementItem.props), [children]);
  const childrenOptions = _react.default.useMemo(() => selectOptions.map((elementItem, idx) => {
    const {
      value,
      children: itemChildren
    } = elementItem;
    return /*#__PURE__*/_react.default.createElement(_components.SelectOption, {
      id: id,
      key: idx,
      value: value,
      onClick: onItemClick
    }, itemChildren);
  }), [id, selectOptions, onItemClick]);
  const handleInputBlur = _react.default.useCallback(event => {
    onInputBlur?.();
    onBlur?.(internalSelectedOption, event);
  }, [onInputBlur, onBlur, internalSelectedOption]);
  const handleInputFocus = _react.default.useCallback(() => {
    onInputFocus?.();
    onFocus?.();
  }, [onInputFocus, onFocus]);
  const haveIcon = _react.default.useMemo(() => (0, _ark.isDefined)(icon), [icon]);
  const selectedText = _react.default.useMemo(() => {
    const selectedOption = selectOptions.find(option => option.value === internalSelectedOption);
    if ((0, _ark.isDefined)(selectedOption) && (0, _ark.isString)(selectedOption.selectedText)) return selectedOption.selectedText;
    if ((0, _ark.isDefined)(selectedOption) && (0, _ark.isDefined)(selectedOption.children)) return selectedOption.children.toString();
    return internalSelectedOption ?? '';
  }, [internalSelectedOption, selectOptions]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _arkReact.concatClassName)('formSelect', haveIcon ? 'formSelect-icon' : null)
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: controlId,
    ref: inputRef,
    type: "text",
    value: selectedText,
    className: (0, _arkReact.concatClassName)('formControl', readOnly ? 'formControl-readOnly' : null, className),
    readOnly: true,
    onClick: () => setOpenMenu(true),
    onBlur: handleInputBlur,
    onFocus: handleInputFocus
  }), icon != null && /*#__PURE__*/_react.default.createElement("div", {
    className: "formInputIcon"
  }, icon), !readOnly && /*#__PURE__*/_react.default.createElement(_dropdownMenu.default, {
    open: openMenu,
    anchorEl: inputRef,
    onClose: () => setOpenMenu(false)
  }, childrenOptions));
};
process.env.NODE_ENV !== "production" ? FormSelect.propTypes = {
  id: _propTypes.default.string,
  selected: _propTypes.default.any,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  icon: _propTypes.default.node,
  required: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  state: _propTypes.default.oneOf(['error', 'warning', 'ok']),
  managed: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func
} : void 0;
FormSelect.defaultProps = {
  id: undefined,
  selected: undefined,
  className: undefined,
  children: undefined,
  icon: undefined,
  required: false,
  readOnly: false,
  state: 'ok',
  managed: false,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined
};
var _default = exports.default = Object.assign(FormSelect, {
  Option: _FormSelectOption.default
});